export default [{
    name: 'daoliu/loading',
    path: '/daoliu/loading',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/loading.vue'),
}, {
    name: 'daoliu/vendor',
    path: '/daoliu/vendor',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/vendor.vue')
}, {
    name: 'daoliu/vendor2',
    path: '/daoliu/vendor2',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/vendor2.vue')
}, {
    name: 'daoliu/vendor3',
    path: '/daoliu/vendor3',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/vendor-xy.vue')
}, {
    name: 'daoliu/bank',
    path: '/daoliu/bank',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/bank.vue')
}, {
    name: 'daoliu/mobile',
    path: '/daoliu/mobile',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/mobile.vue')
}, {
    name: 'daoliu/identity/photo',
    path: '/daoliu/identity/photo',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/identity_photo.vue')
}, {
    name: 'daoliu/identity/face',
    path: '/daoliu/identity/face',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/identity_face.vue')
}, {
    name: 'daoliu/identity/error',
    path: '/daoliu/identity/error',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/identity_error.vue')
}, {
    name: 'daoliu/checking',
    path: '/daoliu/checking',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/checking.vue')
}, {
    name: 'daoliu/sign',
    path: '/daoliu/sign',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/sign.vue')
}, {
    name: 'daoliu/signing',
    path: '/daoliu/signing',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/signing.vue')
}, {
    name: 'daoliu/repay',
    path: '/daoliu/repay',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/repay.vue')
}, {
    name: 'daoliu/plan',
    path: '/daoliu/plan',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/plan.vue')
}, {
    name: 'daoliu/protocol/loan',
    path: '/daoliu/protocol/loan',
    meta: {
        needLogin: true
    },
    component: () => import('@/view/daoliu/loan_reference_contract.vue')
}]